import React, { useEffect, useState, createContext } from "react";

export const GeneralContext = createContext();

const GeneralContextProvider = ({ children }) => {
  const login = Boolean(localStorage.getItem("username") !== undefined);

  const [UID, setUID] = useState(0);
  const [username, setUsername] = useState("");

  const value = {
    UID,
    setUID,
  };

  return (
    <GeneralContext.Provider value={value}>{children}</GeneralContext.Provider>
  );
};

export default GeneralContextProvider;
